import React from 'react';

const MARKUP_REGEX = /(\*\*[^*]+\*\*|\*[^*]+\*|__[^_]+__|_[^_]+_)/g;

const parseMarkup = (text: string): React.ReactNode[] => {
    const parts = text.split(MARKUP_REGEX).filter(Boolean);

    return parts.map((part, index) => {
        if ((part.startsWith('**') && part.endsWith('**')) || (part.startsWith('__') && part.endsWith('__'))) {
            return <strong key={index}>{part.slice(2, -2)}</strong>;
        }

        if ((part.startsWith('*') && part.endsWith('*')) || (part.startsWith('_') && part.endsWith('_'))) {
            return <em key={index}>{part.slice(1, -1)}</em>;
        }

        return part;
    });
};

export default parseMarkup;
